import React, { useCallback, useState } from 'react';
import PdfPreviewPopup from './PdfPreviewPopup';
import DeleteIcon from '../icons/trashR.svg';
import fileIcon from '../icons/file-textBLD.svg';

// Drag & drop zone for a single PDF (same look as the ProductForm file field). Clicking the file
// name opens it in a preview popup; clicking elsewhere in the zone picks a replacement.
// existingFile ({ name, getPdfBlob }) is the PDF already saved, shown until a new file is picked.
const PdfDropzone = ({ name, file, existingFile, onChange, onInvalidFile, placeholderText1, placeholderText2 }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const shownFile = file || existingFile;
  const getPdfBlob = useCallback(async () => (file || existingFile?.getPdfBlob()), [file, existingFile]);

  const selectFile = (selected) => {
    if (!selected) return;
    if (selected.type !== 'application/pdf') {
      onInvalidFile?.();
      return;
    }
    onChange(selected);
  };

  return (
    <>
      <label
        htmlFor={`fileInput-${name}`}
        className="border-2 border-dashed border-gray-300 h-[93px] rounded-md p-4 block cursor-pointer transition-colors"
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          selectFile(e.dataTransfer.files?.[0]);
        }}
      >
        <input
          id={`fileInput-${name}`}
          type="file"
          name={name}
          accept="application/pdf"
          className="hidden"
          onChange={(e) => {
            selectFile(e.target.files?.[0]);
            // Let the same file be picked again after a removal
            e.target.value = '';
          }}
        />
        <div className="flex items-center justify-between gap-3 h-full min-h-[40px]">
          {shownFile ? (
            <>
              <div className="flex items-center ml-[40px] min-w-0 flex-1 h-full">
                <img src={fileIcon} alt="PDF" className="w-8 h-8 shrink-0" />
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setPreviewOpen(true);
                  }}
                  className="text-[14px] font-semibold ml-[20px] text-[#38475D] truncate underline hover:text-primary"
                >
                  {shownFile.name}
                </button>
              </div>
              {file && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onChange(null);
                  }}
                  className="w-8 h-8 p-1 -m-1 mr-[36px] flex items-center justify-center bg-[#F9FAFC] rounded-[12px] border border-[#EF466F4D]"
                >
                  <img src={DeleteIcon} alt="Delete" className="w-5 h-5" />
                </button>
              )}
            </>
          ) : (
            <div className="flex items-center justify-center w-full gap-4 text-center">
              <img src={fileIcon} alt="" className="w-8 h-8" />
              <div className="text-left">
                <p className="text-sm text-gray-500">{placeholderText1}</p>
                <p className="text-sm font-bold text-primary">{placeholderText2}</p>
              </div>
            </div>
          )}
        </div>
      </label>
      <PdfPreviewPopup
        open={previewOpen}
        title={shownFile?.name}
        filename={shownFile?.name}
        getPdfBlob={getPdfBlob}
        onClose={() => setPreviewOpen(false)}
      />
    </>
  );
};

export default PdfDropzone;
